import { mdiEmailOutline, mdiMessageOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const Comms = ({ email, subject, link }: { email?: string; subject?: string; link?: string }) => {
    const { t } = useTranslation()
    const color = useColorModeValue('var(--chakra-colors-gray-250)', 'var(--chakra-colors-gray-500)')
    const iconColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-gray-500)')

    if (!email && !link) {
        return
    }

    const getUrl = () => {
        if (email) {
            return `mailto:${email}?subject=${subject}`
        } else if (link) {
            return link
        }
    }

    return (
        <Link
            data-id="chat-citation-link"
            href={getUrl()}
            isExternal
            textDecor="none"
            _hover={{ textDecor: 'none' }}
            mb="8px"
            display="flex"
            border="1px"
            borderRadius="8px"
            borderColor={color}
            alignItems="center"
            pt="8px"
            pb="8px"
            pl="16px"
            pr="16px"
        >
            <Icon path={email ? mdiEmailOutline : mdiMessageOutline} size={1} color={iconColor} style={{ marginRight: '8px' }} />
            <Text as="span" fontSize="14px" fontWeight="bold">
                {email ? email : t('tasksApprovals.drawer.teamsChat')}
            </Text>
        </Link>
    )
}

export default Comms
